import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Button } from '@mui/material';
import { useNotification } from '../../contexts/NotificationContext';
import { useFeedbackForm } from './shared/hooks/useFeedbackForm';
import { useFeedback } from './shared/services/useFeedbackService';
import FeedbackForm from './shared/sections/FeedbackForm';
import FormPageLayout from '../../components/FormPageLayout';

const FeedbackPage = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { showNotification } = useNotification();
  const { patients, loading, submitFeedback } = useFeedback();
  const { formData, DOCTOR_LIST, handleChange, handlePhoneChange, validate, buildPayload } = useFeedbackForm();

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validate()) return;
    try {
      await submitFeedback(buildPayload());
      showNotification('success', 'Feedback submitted successfully!');
      
      const returnPage = location.state?.page || 0;
      const returnMenu = location.state?.activeMenu || 'Patient Feedback';
      
      setTimeout(() => {
        navigate(`/home?page=${returnPage}`, { 
          state: { activeMenu: returnMenu } 
        });
      }, 1000);
    } catch (error) {
      showNotification('error', error.response?.data?.error || 'Error submitting feedback.');
    }
  };

  return (
    <FormPageLayout 
      title="ADD FEEDBACK" 
      backTo={{ 
        path: `/home?page=${location.state?.page || 0}`, 
        state: { activeMenu: location.state?.activeMenu || 'Patient Feedback' } 
      }} 
      loading={loading}
    >
      <form onSubmit={handleSubmit}>
        <FeedbackForm formData={formData} handleChange={handleChange} handlePhoneChange={handlePhoneChange} patients={patients} DOCTOR_LIST={DOCTOR_LIST} />
        <Button type="submit" variant="contained" color="primary" fullWidth sx={{ mt: 3 }}>Submit Feedback</Button>
      </form>
    </FormPageLayout>
  );
};

export default FeedbackPage;
